// store.js
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const composeEnhancers = compose; // You might later replace this with Redux DevTools compose if needed.

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(...middlewares))
);

window.store = store;

sagaMiddleware.run(sagas);
